import React, { useState, useEffect, useRef } from 'react';

import TablaPaquetes from './Tabla/TablaPaquetes';
import Exportar from './Botones/Exportar';
import EliminarUno from './Dialogos/EliminarUno';
import EliminarVarios from './Dialogos/EliminarVarios';
import CrearModificar from './Dialogos/CrearModificar';
import { leftToolbarTemplate } from '../ComponentsCat/Botones/AgregarEliminar'
import { paqueteVacio } from './Objetos/paqueteVacio';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Service } from '../../../service/Service';
import Spinner from '../../../components/loader/Spinner';
import ErrorSistema from '../../../components/error/ErrorSistema';

import Environment from '../../../Environment'
import Axios from 'axios';
const getRoute = Environment();

const CrudPaquetes = ({ titulos, notificaciones }) => {
    //--------------------| Inicializacion |--------------------
    const licenciaService = new Service()
    licenciaService.baseUrl = `${getRoute}/usuarios`

    //--------------------| Uso de estados |--------------------
    const [products, setProducts] = useState([]);
    const [product, setProduct] = useState(paqueteVacio);
    const [productDialog, setProductDialog] = useState(false);
    const [deleteProductDialog, setDeleteProductDialog] = useState(false);
    const [deleteProductsDialog, setDeleteProductsDialog] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [tieneId, setTieneId] = useState(false)
    //--> Estilos de inputs
    const [estiloNombre, setEstiloNombre] = useState("")
    const [estiloAP, setEstiloAP] = useState("")
    const [estiloAM, setEstiloAM] = useState("")
    //--> Interaccion con back-end
    const [isLoading,setIsLoading]=useState(false)
    const [error, setError] = useState(null)

    const toast = useRef(null);
    const dt = useRef(null);

    //--------------------| Funciones de Crud |--------------------
    //--> Crear nuevo producto
    const createProduct = async(product) => {
        setIsLoading(true)
        setError(null)
        try {
            await licenciaService.create(product)
            const data = await licenciaService.readAll()
            setProducts(data)  
        } catch (error) { setError(error.message) }
        setIsLoading(false)
        toast.current.show({ severity: 'success', summary: 'Atencion!', detail: `${notificaciones.creacion}`, life: 3000 });
    }
    //--> Actualizar producto
    // const updateProduct = (product) => {
    //     usuarioService.update(product).
    //         then(() => usuarioService.readAll().then(res => setProducts(res))).
    //         catch(e => console.log(e))
    // }
    const updateProduct = async(product) => {
        setIsLoading(true)
        setError(null)
        try {
            await licenciaService.update(product)
            const data = await licenciaService.readAll()
            setProducts(data)  
        } catch (error) { setError(error.message) }
        setIsLoading(false)
        toast.current.show({ severity: 'success', summary: 'Atencion!', detail: `${notificaciones.modificacion}`, life: 3000 });
    }
    //--> Eliminar producto
    // const deleteProduct = (id) => {
    //     usuarioService.delete(id).
    //         then(() => usuarioService.readAll().then(res => setProducts(res)).
    //             catch(e => console.log(e)))
    // }
    const deleteProduct = async(id) => {
        setIsLoading(true)
        setError(null)
        try {
            await licenciaService.delete(id)
            const data = await licenciaService.readAll()
            setProducts(data)  
        } catch (error) { setError(error.message) }
        setIsLoading(false)
        toast.current.show({ severity: 'success', summary: 'Atencion!', detail: `${notificaciones.eliminacion}`, life: 3000 });
    }

    //--------------------| Dialogos |--------------------
    //--> Nuevo gasto
    const openNew = () => {
        setProduct(paqueteVacio);
        setProductDialog(true);
        setEstiloNombre("")
        setEstiloAP("")
        setEstiloAM("")
    }
    //--> Ocultar dialogo crear
    const hideDialog = () => { setProductDialog(false) }
    //--> Ocultar dialogo de eliminar 1 producto
    const hideDeleteProductDialog = () => { setDeleteProductDialog(false) }
    //--> Ocultar dialogo de eliminar varios productos
    const hideDeleteProductsDialog = () => { setDeleteProductsDialog(false) }
    //--> Eliminar 1 producto
    const confirmDeleteProduct = (product) => {
        setProduct(product);
        setDeleteProductDialog(true);
    }
    //--> Eliminar varios productos
    const confirmDeleteSelected = () => { setDeleteProductsDialog(true) }

//--------------------| Acciones de crud |--------------------
    //------> Actualizar campo de producto
    const updateField = (data, field) => {
        console.log(product)
        setProduct({
        ...product,
        [field]: data,
        });
    };
    //------> Agregar nuevo registro
    const saveProduct = () => {
        if (!product.id) { createProduct(product) }
        else { updateProduct(product) }
        setProduct(paqueteVacio);
        setProductDialog(false);
    }
    //------> Eliminar 1 producto
    const _deleteProduct = () => {
        deleteProduct(product.id)
        setProduct(paqueteVacio)
        setDeleteProductDialog(false)
    }
    //------> Eliminar varios productos
    const deleteSelectedProducts = () => {
        selectedProducts.forEach(registro => deleteProduct(registro.id))
        setDeleteProductsDialog(false);                                         // Ocultara dialogo
        setSelectedProducts(null);                                              // Elemetos seleccionados = 0
    }
    //------> Editar producto
    const _editProduct = async(product) => {
        setIsLoading(true)
        const respuesta = await Axios.post(`${getRoute}/usuarios/${product.id}`)
        setProduct(respuesta.data)
        setIsLoading(false)
        setProductDialog(true)
    }

//--------------------| Botones en pantalla |--------------------
    //------> Botones para agregar/eliminar productos
    const BotonesCabezal=leftToolbarTemplate(openNew, confirmDeleteSelected, selectedProducts);

    //------> Boton para exportar
    const ExportarRegistros=Exportar(products);

    //------> Botones parte derecha
    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <Button 
                    icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" 
                    onClick={() => _editProduct(rowData)} />
                <Button 
                    icon="pi pi-trash" className="p-button-rounded p-button-warning" 
                    onClick={() => confirmDeleteProduct(rowData)} />
            </>
        );
    }

//--------------------| Obtener registros de back-end |--------------------
    //---> Obtendra los datos del back-end
    useEffect(()=>{
        const cargarDatos = async () => {
            setIsLoading(true)
            setError(null)
            try{
                const data = await licenciaService.readAll()
                setProducts(data)  
            } catch (error) { setError(error.message) }
            setIsLoading(false)
        }
        cargarDatos()
        return () => { setProducts([]) }
    },[]); // eslint-disable-line react-hooks/exhaustive-deps    

    //--------------------| Abilitar o inhabilitar boton |--------------------
    useEffect(() => {
        // Edicion
        if (product.id) { setTieneId(false) }
        // Creacion
        else { setTieneId(true) }
    },[product])

    //--------------------| Valor que regresara |--------------------
    return (
        <div className="datatable-crud-demo">
            <Toast ref={toast} />
            {!isLoading && !error && (
            <TablaPaquetes
                BotonesCabezal={BotonesCabezal} 
                ExportarRegistros={ExportarRegistros} 
                dt={dt} 
                products={products} 
                selectedProducts={selectedProducts} 
                setSelectedProducts={setSelectedProducts} 
                actionBodyTemplate={actionBodyTemplate} 
                />)}

            {isLoading && <Spinner />}
            {error && <ErrorSistema texto={error} />}

            <CrearModificar
                productDialog={productDialog}
                titulos={titulos}
                saveProduct={saveProduct}
                hideDialog={hideDialog}
                product={product}
                updateField={updateField}
                tieneId={tieneId}
                estiloAP={estiloAP} setEstiloAP={setEstiloAP}
                estiloAM={estiloAM} setEstiloAM={setEstiloAM}
                estiloNombre={estiloNombre} setEstiloNombre={setEstiloNombre}
            />

            <EliminarUno
            deleteProductDialog={deleteProductDialog} 
            _deleteProduct={_deleteProduct}
            hideDeleteProductDialog={hideDeleteProductDialog} 
            product={product}
            />

            <EliminarVarios 
            deleteProductsDialog={deleteProductsDialog}
            deleteSelectedProducts={deleteSelectedProducts}
            hideDeleteProductsDialog={hideDeleteProductsDialog}
            product={product}
            />
        </div>
    );
}

export default CrudPaquetes
